import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

const AvatarUpdateButton: React.FC<Props> = ({ user, isSmallScreen }) => {
	const history = useHistory();

	return (
		<AvatarButton
			isSmallScreen={isSmallScreen}
			onClick={() => {
				history.push('?modal=avatar-upload');
			}}
		>
			<AvatarImg src={user && user.avatar?.large} alt={user && user.name} />
		</AvatarButton>
	);
};
export default AvatarUpdateButton;

interface Props {
	user: PortalUser;
	isSmallScreen: boolean;
}

const AvatarButton = styled.button<{ isSmallScreen: boolean }>`
	margin: 30px;
	height: ${({ isSmallScreen }) => (isSmallScreen ? '70px' : '100px')};
	width: ${({ isSmallScreen }) => (isSmallScreen ? '70px' : '100px')};

	&:focus {
		outline: none;
	}
`;

const AvatarImg = styled.img`
	border-width: 1px;
	border-radius: 9999px;
	border-color: #ffffff;
`;
